import { useMemo } from 'react';
import { getCurriculumAdapterById } from '../adapters/registry';
import { getSquadCurriculumId } from '../../squads/utils/curriculum';
import { Squad } from '../../../types';

export function useCurriculumAdapter(opts?: { squad?: Pick<Squad, 'curriculumId'> | null; curriculumId?: string | null }) {
  const { squad, curriculumId } = opts || {};
  return useMemo(() => {
    const id = curriculumId ?? getSquadCurriculumId(squad || null);
    return getCurriculumAdapterById(id);
  }, [squad?.curriculumId, curriculumId]);
}
